import { render, staticRenderFns } from "./refund-list.vue?vue&type=template&id=3dbecc80"
import script from "./refund-list.vue?vue&type=script&lang=js"
export * from "./refund-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports